<template>
  <div>
    <el-button type="primary" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-dialog
        title="新加产品"
        :visible.sync="openStatus"
        width="60%"
        :fullscreen="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-form label-width="120px">
          <el-form-item label="名称">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="存货编码">
            <el-input v-model="form.model_code" placeholder="请输入存货编码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="toSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
      form: {
        name: '',
        model_code: '',
      }
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.form = {
        name: '',
        model_code: '',
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        name: '',
        model_code: '',
      }
      _this.openStatus = false;
    },
    toSubmit() {
      const _this = this;
      _this.submitIng = false;
      _this.$api.productCreate(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.closeSee();
            _this.$emit('finish', res);
            _this.$message.success('添加成功');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    }
  },
};
</script>